const benefits = [
  {
    icon: 'ri-time-line',
    title: 'Oszczędność czasu',
    description: 'Gotowe listy produktów zamiast wielogodzinnego wyszukiwania. Znajdź to, czego potrzebujesz w kilka minut.',
  },
  {
    icon: 'ri-star-line',
    title: 'Najpopularniejsze produkty',
    description: 'Sneakersy, ubrania, dodatki i trendowe produkty starannie wyselekcjonowane dla Ciebie.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Lepsze decyzje zakupowe',
    description: 'Porównuj produkty przed zakupem. Podejmuj świadome decyzje dzięki sprawdzonym informacjom.',
  },
];

export default function WhyChooseSection() {
  return (
    <section id="why-choose" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-4">
          Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?
        </h2>
        <div className="flex justify-center mb-12">
          <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60 hover:border-accent-200/60 transition-all group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${benefit.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}